import mountApp   from 'cfg/mountApp';
import SignupCard from './Vue/SignupCard.vue';


export default (selector, options = {}) => {
  const vueOptions = {
    translationDomain: 'auth',
    components: { SignupCard },
    data() {
      return {
        recaptchaKey  : options.recaptchaKey  || '',
        mondiadApiUrl : options.mondiadApiUrl || '',
      };
    },
  };

  return mountApp({...options, ...vueOptions}, selector);
};
